import { FC, lazy, useEffect } from 'react';
import { PageSpinner } from 'src/components/spinner-container';
import { Successful } from 'src/hooks/use-axios';
import { useOperatorDetails } from 'src/pages/settings/organisation/company-information/edit-operator-information/use-operator-details';
import { useOrganisationDetails } from 'src/pages/settings/organisation/company-information/use-organisation-details';
import { OrganisationServiceRequest } from 'src/pages/settings/organisation/use-organisation-service';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(
  () =>
    import(
      'src/pages/settings/organisation/company-information/edit-operator-information/page'
    )
);
type Props = {
  organisationService: Successful<OrganisationServiceRequest>;
  title: string;
};

export const EditTsoInformation: FC<Props> = ({
  organisationService,
  title,
}) => {
  if (!organisationService.response.data._links.getMyOrganisationDetails)
    throw new Forbidden();

  const organisationDetails = useOrganisationDetails({
    url: organisationService.response.data._links.getMyOrganisationDetails.href,
  });

  useEffect(() => {
    if (
      organisationDetails.response &&
      !organisationDetails.response.data._links.tsoDetails
    )
      throw new Forbidden();
  }, [organisationDetails]);

  const operatorData = useOperatorDetails({ organisationDetails });

  if (!(organisationDetails.response && operatorData.response))
    return <PageSpinner />;

  return <Page operatorData={operatorData} title={title} />;
};

export const EditSsoInformation: FC<Props> = ({
  organisationService,
  title,
}) => {
  if (!organisationService.response.data._links.getMyOrganisationDetails)
    throw new Forbidden();

  const organisationDetails = useOrganisationDetails({
    url: organisationService.response.data._links.getMyOrganisationDetails.href,
  });

  useEffect(() => {
    if (
      organisationDetails.response &&
      !organisationDetails.response.data._links.ssoDetails
    )
      throw new Forbidden();
  }, [organisationDetails]);

  const operatorData = useOperatorDetails({ organisationDetails });

  if (!(organisationDetails.response && operatorData.response))
    return <PageSpinner />;

  return <Page operatorData={operatorData} title={title} />;
};
